export default __webpack_public_path__ + "images/6fe00e1ebd0abe9ebea7bde3c70ad6b3.png";